import { render, staticRenderFns } from "./AuthorNetwork.vue?vue&type=template&id=4d20717e&scoped=true"
import script from "./AuthorNetwork.vue?vue&type=script&lang=js"
export * from "./AuthorNetwork.vue?vue&type=script&lang=js"
import style0 from "./AuthorNetwork.vue?vue&type=style&index=0&id=4d20717e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20717e",
  null
  
)

export default component.exports